import './App.css';
import Home from "./components/pages/home";
import {BrowserRouter, Route, Routes} from "react-router-dom";
import Historias from "./components/pages/historias";
import PageInfo from "./components/pages/pageInfo";
import Videojuegos from "./components/pages/videojuegos";
import resistanceReborn from "./images/resistanceReborn.png";
import lordOscuro from "./images/darth-vader-comic.jpg";
import riseEmpire from "./images/riseEmpire.jpg";
import heirJedi from "./images/heirJedi.jpg";
import masterApprentice from "./images/master&apprentice.jpg";
import forceUnleashed from "./images/theForceUnleashed.jpg";
import skywalkerSaga from "./images/skywalkerSaga.jpg";
import fallenOrder from "./images/fallenOrder.jpg";
import outlaws from "./images/outlaws.jpg";
import battlefront from "./images/battlefront.png";
import jediSurvivor from "./images/jediSurvivor.png";
import Personajes from "./components/pages/personajes.js";
import luke from "./images/lukeSkywalker.jpg";
import yoda from "./images/yoda.jpg";
import kylo from "./images/kylo.jpg";
import plagueis from "./images/plagueis.jpg";
import NotFound from "./components/pages/notFound";
function App() {
    const infoHistorias = [
        {
            id: 0,
            image: resistanceReborn,
            text: "La galaxia vuelve a respirar miedo tras la caída de la Nueva República. La Primera Orden se expande con rapidez, ocupando sistemas enteros y silenciando cualquier oposición. Lo que queda de los antiguos aliados se dispersa, perseguidos y sin recursos. Sin embargo, en los rincones olvidados del espacio, antiguos pilotos, espías, mecánicos y soldados comienzan a reencontrarse. No buscan gloria, solo evitar que la oscuridad gobierne para siempre.\n" +
                "\n" +
                "La Resistencia nace como un movimiento frágil, obligado a esconderse, a moverse constantemente y a confiar en pocos. Cada misión es una apuesta contra la aniquilación: rescatar prisioneros, robar información, sabotear bases enemigas. A través del sacrificio y la lealtad, descubren que no luchan solo contra una flota, sino contra el miedo que intenta paralizar a toda la galaxia. En medio del caos, surge la pregunta que los define: ¿es posible encender una chispa cuando todo parece consumido por la sombra?",
            side: "light",
            title: "El renacer de la resistencia"
        },
        {
            id:1,
            image: lordOscuro,
            text: "Tras la traición al Consejo Jedi y la pérdida de todo aquello que amaba, Anakin Skywalker deja de existir. En su lugar camina Darth Vader, envuelto en una armadura que no solo mantiene su cuerpo con vida, sino que también encierra su alma. Bajo la mirada constante del Emperador Palpatine, Vader debe probar que es digno del título de Lord Sith, persiguiendo a los Jedi sobrevivientes y aplastando cualquier signo de rebelión.\n" +
                "\n" +
                "Cada misión lo enfrenta tanto a enemigos externos como a recuerdos que se niegan a morir. Las voces del pasado, la culpa y la rabia se mezclan con el poder del lado oscuro. Vader aprende que gobernar mediante el terror exige renunciar a toda compasión. Sin embargo, cuanto más fuerte se vuelve, más clara resulta la lucha interna: la máquina que lo mantiene con vida también lo separa de aquello que una vez fue humano. Esta es la historia de un guerrero que domina la galaxia, pero que ya no logra dominarse a sí mismo.",
            side: "dark",
            title: "Darth Vader: Lord Oscuro"
        },
        {
            id:2,
            image: riseEmpire,
            text: "La República, corroída por la corrupción y la guerra, finalmente colapsa. Palpatine aprovecha el caos para proclamarse Emperador y promete orden a una galaxia cansada de conflictos. Lo que comienza como una transición política se convierte rápidamente en una dictadura galáctica. Los senadores pierden poder, los sistemas son vigilados y el ejército imperial se despliega como una sombra interminable.\n" +
                "\n" +
                "Planetas enteros son sometidos bajo la excusa de la estabilidad. La propaganda reemplaza la verdad y el miedo se convierte en herramienta de gobierno. Mientras los antiguos héroes desaparecen, ciudadanos comunes deben decidir entre obedecer o resistir. Esta historia muestra no solo cómo nace el Imperio, sino cómo una galaxia entera permite que la libertad sea intercambiada por una falsa sensación de seguridad.",
            side: "dark",
            title: "El ascenso del Imperio"
        },
        {
            id:3,
            image: heirJedi,
            text: "Mucho después de la caída de la Orden Jedi, sus nombres se convierten en leyenda. Para la mayoría, son solo cuentos del pasado. Pero en un remoto sistema, un joven descubre que la Fuerza fluye dentro de él de forma incontrolable. Visiones, sueños y recuerdos que no son suyos comienzan a perseguirlo, señalando un destino que no comprende.\n" +
                "\n" +
                "Guiado por fragmentos de antiguos textos y encuentros con sobrevivientes del viejo orden, el heredero inicia un viaje peligroso. No solo debe aprender a controlar la Fuerza, sino también a entender lo que significa ser Jedi en una galaxia rota. Entre tentaciones, enemigos y dudas, la historia explora si es posible reconstruir una tradición basada en la luz cuando el universo ya ha aprendido a vivir en la oscuridad.",
            side: "light",
            title: "El heredero del Jedi"
        },
        {   id:4,
            image: masterApprentice,
            text: "Antes de que los Sith se revelen abiertamente, la Orden Jedi vive una frágil calma. Un maestro veterano recibe la misión de entrenar a un aprendiz con un talento poco común. Más allá de las técnicas de combate, el verdadero desafío está en formar el carácter: paciencia, autocontrol y conexión con la Fuerza.\n" +
                "\n" +
                "A lo largo de misiones diplomáticas y entrenamientos intensos, ambos descubren que el vínculo entre maestro y alumno es más complejo de lo que parece. El aprendiz cuestiona el pasado de la Orden, mientras el maestro enfrenta errores que aún lo persiguen. La historia no trata solo de aprender a luchar, sino de comprender que cada elección puede acercarlos a la luz… o empujarlos lentamente hacia la sombra que se aproxima.",
            side: "light",
            title: "Maestro y aprendiz"
        }
    ];
    const infoVideojuegos = [
        {
            sectionName: 'videojuegos',
            id: 0,
            image: forceUnleashed,
            text: "una historia secreta del aprendiz oculto de darth vader, enviado a cazar jedi sobrevivientes y a desatar el verdadero poder de la fuerza. entre misiones imperiales y decisiones peligrosas, el protagonista descubre que su destino podría cambiar el equilibrio entre el imperio y la rebelión.",
            side: "dark",
            title: "the force unleashed"
        },
        {
            sectionName: 'videojuegos',
            id: 1,
            image: skywalkerSaga,
            text: "un viaje a través de toda la saga de star wars contado con humor y acción. desde la amenaza fantasma hasta el ascenso de la primera orden, los héroes más icónicos reviven sus aventuras en un formato divertido, pero fiel al espíritu galáctico.",
            side: "light",
            title: "lego star wars: the skywalker saga"
        },
        {
            sectionName: 'videojuegos',
            id: 2,
            image: fallenOrder,
            text: "tras la orden 66, un joven padawan sobrevive ocultándose del imperio. mientras huye de los inquisidores, debe reconectar con la fuerza, enfrentar su pasado y decidir si volver a empuñar el sable láser en una galaxia que ya no cree en los jedi.",
            side: "light",
            title: "star wars jedi: fallen order"
        },
        {
            image: outlaws,
            sectionName: 'videojuegos',
            id: 3,
            text: "en una galaxia dominada por sindicatos criminales y el poder imperial, una forajida busca libertad realizando trabajos peligrosos, robos y alianzas inciertas. cada decisión puede llevarla más cerca de la gloria… o directo a una tumba espacial.",
            side: "dark",
            title: "star wars outlaws"
        },
        {
            image: battlefront,
            sectionName: 'videojuegos',
            id: 4,
            text: "en plena guerra galáctica, soldados comunes viven el conflicto desde dentro del imperio y la rebelión. la historia muestra cómo la lealtad, la duda y la identidad chocan cuando un simple trooper comienza a cuestionar el sistema que juró defender.",
            side: "dark",
            title: "star wars battlefront ii"
        },
        {

            id: 5,
            sectionName: 'videojuegos',
            image: jediSurvivor,
            text: "la lucha continúa para un jedi perseguido por el imperio. más fuerte pero también más marcado por la guerra, debe proteger a sus aliados, explorar antiguos secretos de la fuerza y enfrentar la oscuridad que amenaza con consumirlo.",
            side: "light",
            title: "star wars jedi: survivor"
        }

    ]
    const infoPersonajes = [
        {
            sectionName: "personajes",
            id: 0,
            image: luke,
            text: "un granjero de tatooine que descubre su conexión con la fuerza y se convierte en la nueva esperanza de la galaxia. guiado por antiguos maestros, luke aprende que el verdadero poder no está solo en el combate, sino en la compasión y la fe en la luz.",
            side: "light",
            title: "luke skywalker"
        },
        {
            sectionName: "personajes",
            id: 1,
            image: yoda,
            text: "el más sabio de los jedi, pequeño en tamaño pero inmenso en conocimiento. yoda entrenó generaciones enteras, enseñando que la fuerza fluye a través del equilibrio, la paciencia y la conexión con todo lo que vive.",
            side: "light",
            title: "yoda"
        },
        {
            sectionName: "personajes",
            id: 2,
            image: kylo,
            text: "nacido como ben solo, fue seducido por el lado oscuro y renació como kylo ren. dividido entre la luz y la sombra, su camino está marcado por la ira, la duda y la búsqueda de un poder que logre silenciar su conflicto interno.",
            side: "dark",
            title: "kylo ren"
        },
        {
            sectionName: "personajes",
            id: 3,
            image: plagueis,
            text: "un lord sith legendario obsesionado con vencer a la muerte. darth plagueis exploró los secretos más profundos del lado oscuro, capaz de manipular la vida misma, pero irónicamente incapaz de salvarse de su propio aprendiz.",
            side: "dark",
            title: "darth plagueis the wise"
        }
    ]
  return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/historias" element={<Historias />} />
                <Route path={`/historias/:id`} element={<PageInfo info={infoHistorias}/>} />
                <Route path={`/videojuegos/`} element={<Videojuegos />} />
                <Route path={`/videojuegos/:id`} element={<PageInfo info={infoVideojuegos}/>} />
                <Route path="/personajes" element={<Personajes />} />
                <Route path={`/personajes/:id`} element={<PageInfo info={infoPersonajes} />} />
                <Route path='*' element={<NotFound />} />
            </Routes>
        </BrowserRouter>

  );
}

export default App;
